@if (scoreChartData$ | async; as chartData) {
  <div class="chart-wrapper">
    <div class="chart-wrapper__chart">
      @if (chartData.get(chartType.ScoreDistribution); as scoreChart) {
        <div
          echarts
          class="chart-wrapper__chart--content"
          [options]="scoreChart"></div>
      }
    </div>
    <app-statistics-total
      [totalData]="chartData.get(chartType.ScoreTotal)"
      [titleKey]="chartTitle[chartType.ScoreTotal]">
    </app-statistics-total>
  </div>
}
